import React, { useContext } from "react";
import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";

interface SVGProps extends React.SVGProps<SVGSVGElement> {
  isActive?: boolean;
  fill?: string;
}

const ActiveActivityRecordIcon: React.FC<SVGProps> = ({ isActive = false, fill, ...props }) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = fill?.trim() ? fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_30500_50323)">
        <g filter={isActive ? "url(#filter0_dddd_30500_50323)" : undefined}>
          <path
            d="M19.2188 13.8794C18.8729 13.8794 18.5928 13.5926 18.5928 13.2385V12.0901C18.5928 11.736 18.8729 11.4492 19.2188 11.4492C19.5647 11.4492 19.8448 11.736 19.8448 12.0901V13.2385C19.8448 13.5926 19.5647 13.8794 19.2188 13.8794Z"
            fill={finalColor}
          />
          <path
            d="M19.2188 10.3235C18.8729 10.3235 18.5928 10.0367 18.5928 9.68261V7.72778C18.5928 7.64606 18.5797 7.56541 18.5547 7.48796C18.4457 7.15201 18.6225 6.78935 18.9507 6.67718C19.2788 6.56502 19.633 6.74662 19.7426 7.08257C19.8104 7.29087 19.8448 7.50772 19.8448 7.72778V9.68261C19.8448 10.0367 19.5647 10.3235 19.2188 10.3235ZM17.359 6.4614C17.2526 6.4614 17.1451 6.43363 17.0465 6.37541L15.0119 5.1726C14.7125 4.99581 14.6097 4.60378 14.7829 4.2972C14.9556 3.99062 15.339 3.8854 15.6379 4.06272L17.6725 5.26554C17.972 5.44233 18.0747 5.83436 17.9015 6.14094C17.7857 6.34657 17.575 6.4614 17.359 6.4614Z"
            fill={finalColor}
          />
          <path
            d="M13.2892 4.05932C13.1828 4.05932 13.0753 4.03155 12.9767 3.97333L12.0053 3.39916C11.7059 3.22237 11.6031 2.83034 11.7763 2.52376C11.949 2.21718 12.3324 2.11196 12.6313 2.28929L13.6027 2.86345C13.9022 3.04024 14.0049 3.43228 13.8317 3.73886C13.7159 3.94449 13.5052 4.05932 13.2892 4.05932Z"
            fill={finalColor}
          />
          <path d="M16.9368 12.9219H21.5L19.2186 15.257L16.9368 12.9219Z" fill={finalColor} />
          <path
            d="M10.6723 22.5C10.3275 22.5 9.98317 22.4092 9.67589 22.2276L2.49642 17.9841C1.88188 17.6209 1.5 16.9437 1.5 16.2168V7.72977C1.5 7.00285 1.88188 6.32614 2.49642 5.96241L9.90126 1.58592C10.2007 1.40913 10.5836 1.51382 10.7563 1.8204C10.929 2.12698 10.8267 2.51901 10.5273 2.6958L3.12245 7.07282C2.89395 7.20795 2.75205 7.45951 2.75205 7.72977V16.2168C2.75205 16.487 2.89395 16.7386 3.12245 16.8737L10.3014 21.1172C10.5299 21.2523 10.8137 21.2523 11.0427 21.1172L18.5775 16.6633C18.8769 16.4865 19.2598 16.5912 19.4325 16.8977C19.6052 17.2043 19.5029 17.5964 19.2035 17.7731L11.6687 22.2271C11.3615 22.4087 11.0166 22.4995 10.6723 22.4995V22.5Z"
            fill={finalColor}
          />
          <path
            d="M11.3327 12.8793L10.1704 12.382L12.2394 7.60707C12.3161 7.42975 12.5185 7.35016 12.6917 7.42868L13.1602 7.64125C13.3334 7.71977 13.479 7.927 13.4023 8.10433L11.3333 12.8793H11.3327Z"
            fill={finalColor}
          />
          <path
            d="M7.99917 14.2689L7.74928 13.8112C7.65538 13.6397 7.71798 13.4229 7.88701 13.3305L10.7307 11.7891L11.3338 12.8781L8.47756 14.4265C8.31323 14.5162 8.08995 14.4361 7.99917 14.2695V14.2689Z"
            fill={finalColor}
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_dddd_30500_50323"
          x="-0.5"
          y="-0.5"
          width="24"
          height="25"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.286275 0 0 0 0 0.670588 0 0 0 0 0.952941 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_30500_50323" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.286275 0 0 0 0 0.670588 0 0 0 0 0.952941 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_30500_50323"
            result="effect2_dropShadow_30500_50323"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.286275 0 0 0 0 0.670588 0 0 0 0 0.952941 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_30500_50323"
            result="effect3_dropShadow_30500_50323"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.286275 0 0 0 0 0.670588 0 0 0 0 0.952941 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_30500_50323"
            result="effect4_dropShadow_30500_50323"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect4_dropShadow_30500_50323"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_30500_50323">
          <rect width="23" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ActiveActivityRecordIcon;
